"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const uuid_1 = require("uuid");
const mui_1 = require("tss-react/mui");
const TableSortLabel_1 = __importDefault(require("@mui/material/TableSortLabel"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const AssignmentIndRounded_1 = __importDefault(require("@mui/icons-material/AssignmentIndRounded"));
const LockOutlined_1 = __importDefault(require("@mui/icons-material/LockOutlined"));
const memorizedRulesSelectors_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesSelectors");
const memorizedRulesTypes_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesTypes");
const core_1 = require("companion-app-components/utils/core");
const QButton_1 = __importDefault(require("components/QButton"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const styles_1 = __importDefault(require("./styles"));
const Row_1 = __importDefault(require("./Row"));
const utils_1 = require("./utils");
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const headCells = [
    { id: 'payee', label: 'Payee Name' },
    { id: 'rules', label: 'Rules' },
    { id: 'coa', label: 'Category' },
    { id: 'tags', label: 'Tags' },
    { id: 'memo', label: 'Memo' },
    { id: 'amount', label: 'Amount' },
    { id: 'lock', label: '' },
];
const isColumnSortable = ['payee', 'memo', 'amount'];
const MemorizedPayee = (props) => {
    const memorizedPayees = (0, react_redux_1.useSelector)((state) => (0, memorizedRulesSelectors_1.getMemorizedRulesById)(state), react_redux_1.shallowEqual);
    const { classes, cx } = useStyles(props);
    const [memorizedPayeeList, setMemorizedPayeeList] = React.useState(memorizedPayees);
    // FIXME: Update MemorizedRuleProps
    // @ts-expect-error: Argument of type '{}' is not assignable to parameter of type 'MemorizedRuleProps'.
    const [newMemorizedPayee, setNewMemorizedPayee] = React.useState((0, immutable_1.Record)({}));
    const [disableAll, setDisableAll] = React.useState(false);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('payee');
    const trackMemPayeePage = () => {
        const totalMemRules = memorizedPayees.size;
        const totalAmountBasedRules = memorizedPayees.count((rule) => !!(rule === null || rule === void 0 ? void 0 : rule.amountCondition));
        const totalAccountBasedRules = memorizedPayees.count((rule) => Array.isArray(rule === null || rule === void 0 ? void 0 : rule.accountIds) && rule.accountIds.length > 0);
        const conditionalRuleCount = totalAmountBasedRules + totalAccountBasedRules;
        const trackingData = {
            totalMemorizedRuleCount: totalMemRules,
            conditionalRule: conditionalRuleCount > 0 ? 'Yes' : 'No',
        };
        if (conditionalRuleCount > 0) {
            trackingData.conditionalRuleCount = conditionalRuleCount;
            trackingData.amountConditionRuleCount = totalAmountBasedRules;
            trackingData.accountConditionRuleCount = totalAccountBasedRules;
        }
        core_1.tracker.track(core_1.tracker.events.categoryRuleList, trackingData);
    };
    React.useEffect(() => {
        const sortedMemPayelist = (0, utils_1.sortMemorizePayeeList)(order, orderBy, memorizedPayees);
        setMemorizedPayeeList(sortedMemPayelist);
        trackMemPayeePage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memorizedPayees]);
    React.useEffect(() => {
        const sortedMemPayelist = (0, utils_1.sortMemorizePayeeList)(order, orderBy, memorizedPayeeList);
        setMemorizedPayeeList(sortedMemPayelist);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order, orderBy]);
    const orderTable = (attr) => {
        setOrder(order === 'asc' ? 'desc' : 'asc');
        setOrderBy(attr);
    };
    const handleAdd = () => {
        const clientId = (0, uuid_1.v4)().toUpperCase();
        // @ts-expect-error: Type 'number' is not assignable to type 'string'.
        setNewMemorizedPayee((0, memorizedRulesTypes_1.mkMemorizedRule)({ id: 0, clientId }));
        setDisableAll(true);
    };
    const renderHeader = () => (<div className={classes.header}>

      {headCells.map((headCell) => {
            const sortable = isColumnSortable.find((headerId) => headCell.id === headerId);
            return (<div key={headCell.id} id={`${headCell.id}-header`} onClick={() => sortable && orderTable(headCell.id)} role="presentation" className={cx({ [classes.tdHeader]: sortable })}>
            {headCell.id === 'amount' && <TableSortLabel_1.default active={orderBy === headCell.id} direction={order}/>}
            <Typography_1.default variant="body2" className={classes.thFont}>{headCell.label}</Typography_1.default>
            {headCell.id !== 'amount' && sortable && <TableSortLabel_1.default active={orderBy === headCell.id} direction={order}/>}
            {headCell.id === 'lock' && <LockOutlined_1.default className={classes.lockIcon}/>}
          </div>);
        })}

      <div />

    </div>);
    const renderRow = (row, skipPayeeName = false) => (<Row_1.default key={row.id || row.clientId} row={row} setDisableAll={setDisableAll} disableAll={disableAll} editable={row === newMemorizedPayee} 
    // @ts-expect-error: Argument of type '{}' is not assignable to parameter of type 'MemorizedRuleProps'.
    removeNewMemorizedPayee={() => setNewMemorizedPayee((0, immutable_1.Record)({}))} rules={memorizedPayeeList} skipPayeeName={skipPayeeName}/>);
    return (<>
      <Grid_1.default container direction="row" justifyContent="space-between" alignItems="center" className={classes.pageHeader}>
        <Typography_1.default variant="h5" className={classes.headlineText}>
          <AssignmentIndRounded_1.default className={classes.headlineIcon}/>
          Memorized Payees
        </Typography_1.default>
        <QButton_1.default id="add-new-rule" variant="contained" onClick={handleAdd} disabled={disableAll}>
          <Add_1.default /> Add
        </QButton_1.default>
      </Grid_1.default>

      {memorizedPayeeList.size <= 0 && !newMemorizedPayee.clientId ? // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
          <ZeroStateView_1.default style={{ margin: 40 }} primary="No Data" secondary="Click the add button to add new memorized payee" size="small"/>
        </> :
            <div>
          {renderHeader()}
          {newMemorizedPayee.clientId && renderRow(newMemorizedPayee)}
          {memorizedPayeeList.size > 0 && memorizedPayeeList.valueSeq().map((row, index, list) => {
                    var _a, _b;
                    const prevRow = index > 0 ? list.get(index - 1) : null;
                    const currentPayee = ((_a = row === null || row === void 0 ? void 0 : row.payee) === null || _a === void 0 ? void 0 : _a.trim()) || '';
                    const prevPayee = ((_b = prevRow === null || prevRow === void 0 ? void 0 : prevRow.payee) === null || _b === void 0 ? void 0 : _b.trim()) || '';
                    const skipPayeeName = !!currentPayee && currentPayee === prevPayee;
                    return renderRow(row, skipPayeeName);
                })}
        </div>}
    </>);
};
exports.default = MemorizedPayee;
